"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const react_hooks_use_error_1 = require("react-hooks-use-error");
const useIndicators_1 = __importDefault(require("./useIndicators"));
function useAsyncHandler(onAction, options) {
    const { isRetryAllowed, strict } = options || {};
    const indicators = (0, useIndicators_1.default)();
    const { isLoading, isDone } = indicators.state;
    const [data, setData] = (0, react_1.useState)(null);
    const { error, setError, isErrored } = (0, react_hooks_use_error_1.useError)(options);
    const handleAction = (0, react_1.useCallback)((actionParam) => __awaiter(this, void 0, void 0, function* () {
        const { isLoading, isDone } = indicators.stateRef.current;
        if (isDone && !isRetryAllowed && strict) {
            console.warn('Action is blocked because isDone is true. Async action is ignored. Possible leak detected.');
            return null;
        }
        if (isLoading) {
            console.warn('action is loading already. Ignore rerunning actions.');
            return null;
        }
        try {
            indicators.set({
                isLoading: true,
            });
            if (isErrored)
                setError(null);
            const result = yield onAction(actionParam);
            setData(result);
            indicators.set({
                isDone: true,
                isLoading: false,
            });
            return result;
        }
        catch (e) {
            setError(e);
            indicators.set({
                isLoading: false,
            });
            throw e; // executor fn should be able to stop function, because of error
        }
    }), [indicators, isErrored, onAction, isRetryAllowed, strict]);
    const reset = (0, react_1.useCallback)(function resetFn() {
        const latestState = indicators.stateRef.current;
        if (latestState.isLoading) {
            // why it is not firing? Even if loading is true already
            console.warn('You are using .reset() during active action. Some data can be overwritten');
        }
        indicators.reset();
        setError(null);
        setData(null);
    }, [indicators]);
    return {
        execute: handleAction,
        isLoading,
        isDone,
        isErrored,
        error,
        reset,
        data,
        indicators,
    };
}
exports.default = useAsyncHandler;
